import { render, staticRenderFns } from "./MostrarQR.vue?vue&type=template&id=6c51a5d9"
import script from "./MostrarQR.vue?vue&type=script&lang=js"
export * from "./MostrarQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports